import React from 'react';
import { useImage } from 'react-image';

function Image({ src, title, extraClasses, ...otherProps }) {
  const { src: composedSrc, error } = useImage({
    srcList: src,
  });

  const renderEmptyAltAttr = (
    otherProps.hasOwnProperty("role") &&
    otherProps.role === "presentation"
  );
  
  if (error) {
    throw new Error(`image error: ${error}`);
  }
  return <img className={`img-responsive ${extraClasses ? extraClasses : ""}`}
    alt={renderEmptyAltAttr ? "" : (title ? title : "image unavailable")}
    {...otherProps}
    src={composedSrc}
  />;
}

export default Image;
